/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_WaitingInputs */

const en_status_waiting = /** @type {(inputs: Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`waiting to be confirmed`)
};

const he_status_waiting = /** @type {(inputs: Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ממתין לאישור`)
};

/**
* | output |
* | --- |
* | "waiting to be confirmed" |
*
* @param {Status_WaitingInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const status_waiting = /** @type {((inputs?: Status_WaitingInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_WaitingInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_waiting(inputs)
	return he_status_waiting(inputs)
});